/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LEAVING_CLAN_LOADER = (
    <FormattedMessage id="clan_leaving.layout.leaving_clan_loader" defaultMessage="Выход из клана..." />
)



// WEBPACK FOOTER //
// ./containers/ClanLeaving/constants.jsx